// extracted by mini-css-extract-plugin
module.exports = {"container":"ImportWaiting_container__3IM4s","tip":"ImportWaiting_tip__1b-nu"};